import React ,{useState,useEffect,useCallback } from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios'
import { BASE_URL } from '../Config/Base'
import { ToastContainer,toast } from 'react-toastify'
import _ from 'lodash';
import Index from '../Assets/Images/delete.png';

const pageSize = 5;



const ParoSectionIndexTopMain = () => {

  const [allusers,setAllusers]= useState([])

  
  const [paginatedPosts, setpaginatedPosts] = useState();
 // const [currentPage, setcurrentPage] = useState(1);

 const [EditParoLink ,SetEditParoLink] =useState([]);
  const [OldLink ,SetOldLink] =useState([]);


  const [fileA, setFileA] = useState();
  const [fileB, setFileB] = useState();
        // console.log(file)


        const handleFileChangeA= (e) => {

          setFileA(e.target.files[0]);
          setFileB(e.target.value)
      
          console.log(fileB,"wertj")
          document.getElementById("Parochangeinput").reset()
          // setTimeout(() => {
          //   setFileB( )
          // }, 1000);
        };
        const handleFileChangeB = (e) => {
        
            setFileB(e.target.files[0]);
        
        };


  useEffect(()=>{
      
    getparoTopsection();
    getRoleData();
    getParouserRole();
  //  setTimeout(() => {
                
  //     getParouserRole();
  //   }, 2000);
   
   },[])


  let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));


/**** Section view task****/

  function getRoleData(){
    let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
    
   let UserRole =  localStorage.getItem("Role");
  
   const body ={
    
    role:UserRole
  
   }
   console.log(body);
  
  
    axios({          
       method: "POST", 
       url: `${BASE_URL}/Paropakari/GetParoLoginUserRole`,      
      //  url: "https://localhost:44312/Api/Tc/GetTcloginUserRole",
       data:body,
       headers: {             
         'Content-Type': 'application/json' , 
         'Authorization':bearer     
       }
     
     })
     .then((response) =>{
      console.log(response.data);
      localStorage.setItem("loginUserRoleaction", JSON.stringify(response.data));
      
       }) 
     
      }



      function getParouserRole(){
    
        let Corprole =  localStorage.getItem("loginUserRoleaction");
        let roledata =  JSON.parse(Corprole);
        let role = roledata.map((e)=>e.userroleaction);
        console.log(role);
        localStorage.setItem("ROLE",role)
      
        let roles = role.toString();
        let roleResult = roles.includes('Add')
        console.log(roleResult)
        localStorage.setItem("add",roleResult)

        let roleResultA = roles.includes('View')
        console.log(roleResultA)
        localStorage.setItem("View",roleResultA)
        
        let roleResultB = roles.includes('Edit')
        console.log(roleResultB)
        localStorage.setItem("Edit",roleResultB)
        
        let roleResultC = roles.includes('Delete')
        console.log(roleResultC)
        localStorage.setItem("Delete",roleResultC)

        let empty = roles.includes('')
         console.log(empty)

        let roleid = localStorage.getItem('RoleId')
        let id = roleid.includes('01')
        console.log(id)

         /*---- Show delete----*/ 

         if(id==true&&empty==true&&roleResult==false&&roleResultA==false&&roleResultB==false&&roleResultC==false)
         {
          setCorpdisplay(true);
          setCorpEditdisplay(true);
          setCorpDeletedisplay(true);
         
         }
         if(id==false&&empty==true&&roleResult==false&&roleResultA==false&&roleResultB==false&&roleResultC==false)
         {
          setCorpdisplay(false);
          setCorpEditdisplay(false);
          setCorpDeletedisplay(false);
           document.getElementById('Paro-TopTbl').style.display ="none";
           document.getElementById('Paro-section-btn').style.display ="none";
           document.getElementById('Paroaction-err').innerHTML = 'Not Assign'
           document.getElementById('Paroaction-err').style.color = "red"
           document.getElementById('Paroaction-err').style.fontWeight = "bold"
           document.getElementById('Paroaction-err').style.alignItems = "center"
           document.getElementById('Paroaction-err').style. justifyContent = "center"
           document.getElementById('Paroaction-err').style. display= "flex"

          
         }

    
 if(roleResult==false&&roleResultA==false&&roleResultB==false&&roleResultC==true){
  setCorpdisplay(true);
  setCorpEditdisplay(false);
  setCorpDeletedisplay(true);
  document.getElementById('Paro-section-btn').style.display ="none";

}


         /*---- Show add view----*/ 
  
    if(roleResult==true&&roleResultA==true&&roleResultB==false&&roleResultC==false){
      setCorpdisplay(false);
      setCorpEditdisplay(false);
      setCorpDeletedisplay(false);
      document.getElementById('Paro-section-btn').style.display ="block";
    
    }

 /*---- Show add ----*/ 
    
    if(roleResult==true&&roleResultA==false&&roleResultB==false&&roleResultC==false){
      setCorpdisplay(false);
      setCorpEditdisplay(false);
      setCorpDeletedisplay(false);
      document.getElementById('Paro-section-btn').style.display ="block";
    
    }

    /*---- Show Edit----*/ 
    
    if(roleResult==false&&roleResultA==true&&roleResultB==false&&roleResultC==false){
      setCorpdisplay(false);
      setCorpEditdisplay(true);
      setCorpDeletedisplay(false);
      document.getElementById('Paro-section-btn').style.display ="none";
    
    }

    

      /*---- Show view----*/ 
    
      if(roleResult==false&&roleResultA==true&&roleResultB==false&&roleResultC==false){
        setCorpdisplay(false);
        setCorpEditdisplay(false);
        setCorpDeletedisplay(false);
        document.getElementById('Paro-section-btn').style.display ="none";
      
      }






        
       /*---- Show add edit delete view----*/
  
       if(roleResult==true&&roleResultA==true&&roleResultB==true&&roleResultC==false){
        setCorpdisplay(true);
        setCorpEditdisplay(true);
        setCorpDeletedisplay(false);
        document.getElementById('Paro-section-btn').style.display ="block";
  
      }
       
        if(roleResult==true&&roleResultA==false&&roleResultB==false&&roleResultC==false){
          
          document.getElementById('Paro-section-btn').style.display ="block";
        }
  
        if(roleResult==false&&roleResultA==true&&roleResultB==false&&roleResultC==false){
         
          setCorpdisplay(false);
          
         document.getElementById('Paro-section-btn').style.display ="none";
       }
  
       if(roleResult==false&&roleResultA==false&&roleResultB==true&&roleResultC==false){
  
        document.getElementById('Paro-section-btn').style.display ="none";
        setCorpDeletedisplay(false);
        setCorpdisplay(true);
       }
  
       if(roleResult==false&&roleResultA==false&&roleResultB==false&&roleResultC==true){
        document.getElementById('Paro-section-btn').style.display ="none";
        setCorpEditdisplay(false);
       
       }
  
  
       /*---- Show add edit delete view----*/
  
      if(roleResult==true&&roleResultA==true&&roleResultB==true&&roleResultC==true){
        setCorpdisplay(true);
        setCorpEditdisplay(true);
        setCorpDeletedisplay(true);
        document.getElementById('Paro-section-btn').style.display ="block";
  
      }
  

  
     
  
       /*---- Show delete and edit view----*/
  
       if(roleResult==true&&roleResultA==true&&roleResultB==false&&roleResultC==true){
        setCorpdisplay(true);
        setCorpEditdisplay(false);
        setCorpDeletedisplay(true);
        document.getElementById('Paro-section-btn').style.display ="block";
  
      }
  
      
  
      
  
  
      /*---- Show add edit ----*/
  
      if(roleResult==true&&roleResultA==false&&roleResultB==true&&roleResultC==false){
        setCorpdisplay(true);
        setCorpEditdisplay(true);
        setCorpDeletedisplay(false);
        document.getElementById('Paro-section-btn').style.display ="block";
  
      }
  
   /*---- Show add view----*/ 
  
    if(roleResult==true&&roleResultA==true&&roleResultB==false&&roleResultC==false){
    setCorpdisplay(false);
    setCorpEditdisplay(false);
    setCorpDeletedisplay(false);
    document.getElementById('Paro-section-btn').style.display ="block";
  
  }
  
  
  /*---- Show edit delete ----*/
  
  if(roleResult==false&&roleResultA==false&&roleResultB==true&&roleResultC==true){
    setCorpdisplay(true);
    setCorpEditdisplay(true);
    setCorpDeletedisplay(true);
    document.getElementById('Paro-section-btn').style.display ="none";
  
  }
  
  
  /*---- Show edit view----*/
  
  if(roleResult==false&&roleResultA==true&&roleResultB==true&&roleResultC==false){
    setCorpdisplay(true);
    setCorpEditdisplay(true);
    setCorpDeletedisplay(false);
    document.getElementById('Paro-section-btn').style.display ="none";
  
  }
  
  
  
  
  
  /*---- Show delete view----*/
  
  if(roleResult==false&&roleResultA==true&&roleResultB==false&&roleResultC==true){
    setCorpdisplay(true);
    setCorpEditdisplay(false);
    setCorpDeletedisplay(true);
    document.getElementById('Paro-section-btn').style.display ="none";
  
  }
  

   /*---- Show add delete----*/
  
   if(roleResult==true&&roleResultA==false&&roleResultB==false&&roleResultC==true){
    setCorpdisplay(true);
    setCorpEditdisplay(false);
    setCorpDeletedisplay(true);
    document.getElementById('Paro-section-btn').style.display ="block";
  
  }
  
  /*---- Show add edit view----*/
  
  if(roleResult==true&&roleResultA==true&&roleResultB==true&&roleResultC==false){
    setCorpdisplay(true);
    setCorpEditdisplay(true);
    setCorpDeletedisplay(false);
    document.getElementById('Paro-section-btn').style.display ="block";
  
  }
  
  /*---- Show add delete  view----*/
  
  if(roleResult==true&&roleResultA==true&&roleResultB==false&&roleResultC==true){
    setCorpdisplay(true);
    setCorpEditdisplay(false);
    setCorpDeletedisplay(true);
    document.getElementById('Paro-section-btn').style.display ="block";
  
  }
  
    
  
  /*---- Show edit delete view----*/
  
  if(roleResult==false&&roleResultA==true&&roleResultB==true&&roleResultC==true){
    setCorpdisplay(true);
    setCorpEditdisplay(true);
    setCorpDeletedisplay(true);
    document.getElementById('Paro-section-btn').style.display ="none";
  
  }
  
      /*---- Show add edit delete view----*/
  
      if(roleResult==true&&roleResultA==true&&roleResultB==true&&roleResultC==true){
        setCorpdisplay(true);
        setCorpEditdisplay(true);
        setCorpDeletedisplay(true);
        document.getElementById('Paro-section-btn').style.display ="block";
  
      }
  
    
    }


    const[Corpdisplay, setCorpdisplay] =useState(true);
      const[CorpEditdisplay, setCorpEditdisplay] =useState(true);
      const[CorpDeletedisplay, setCorpDeletedisplay] =useState(true);
          

  
/*----Add Image and Text----*/

const [file, setFile] = useState();

  
// console.log(file)

const handleFileChange = (e) => {
 
    setFile(e.target.files[0]);

};


/*------ParoAddsection------*/


function ParoAddsection(){

  
  var input = document.getElementById('Parotexttop').value; 
  var Des = document.getElementById('ParotextDes').value; 

  var UserId= localStorage.getItem('UserId')

  if(!input){
    document.getElementById("AddSectopErrA").innerHTML="SectionName Required";
  }
  else if(input){
    document.getElementById("AddSectopErrA").innerHTML=" ";
  }

  if(!Des){
    document.getElementById("AddSectopErrB").innerHTML="Description Required";
  }
  else if(Des){
    document.getElementById("AddSectopErrB").innerHTML=" ";
  }

  if(!file){
    document.getElementById("AddSectopErrC").innerHTML="Image Required";
  }

  else if(file){
    document.getElementById("AddSectopErrC").innerHTML=" ";
  }
  
  if(input&&Des&&file){
 
 
  const body ={
   
    Title:input ,
    Description:Des,
    Image:file,
    ActiveStatus:0,
    DeleteStatus:0,
    Createdby:UserId
    

  }
  console.log(body);


    axios({
  
      method: "POST",
  
      url: `https://localhost:44312/Api/Paropakari/ParoAddTopSection`,
      data:body,
      headers: {
        
        'Content-Type': 'multipart/form-data' ,      
        'Authorization':bearer
      }
    
    })
   
    .then((response) =>{
      console.log(response.data);
      if(response.data.status === "Success"){
   
              alert("Added Successfully!")
            }
        
            // else if(response.data.status === "Success"){
        
            //   toast.success("Section Added Successfully!", {
            //     position: "top-center",
            //     autoClose: 3200,
            //     hideProgressBar: false,
            //     closeOnClick: true,
            //     pauseOnHover: true,
            //     draggable: true,
            //     progress: undefined,
            //     className: 'toast-message'
            //     });
                setTimeout(() => {
                  getparoTopsection()
                  closeTopform()
                }, 500);
              }
             
       )


       
       .catch(error => {
      console.log(error);
       alert("failed !")       
       })
   
      } 
    }
      
      
       /*---GetSection Users----*/

      const[abouttable, setAbouttable] =useState([])

      
      function getparoTopsection(){
        const token = JSON.parse(localStorage.getItem('usertoken'));
      
       

        fetch(`${BASE_URL}/Paropakari/GetSectionParoTop`, {
          method:'GET',
    
        headers : {
    
          "Content-type": "application/json",
    
          "Accept": "application/json",
    
          "Authorization": "Bearer " +`${token}`,
    
          "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
        },
   
  
  })
  
  .then(response => response.json())
  
  
  .then(data => {
  console.log("Section",data)
  setAllusers(data)
setpaginatedPosts(_(data).slice(0).take(pageSize).value());
localStorage.setItem("Paro-TopData", JSON.stringify(data));
   
  });
   }
  

  //  const pageCount = allusers? Math.ceil(allusers.length/pageSize) : 0 ;
  // // if (pageCount === 1)
  // // return null;
  
  // const pages = _.range(1, pageCount+1)
  
  // const pagination =(pageNo)=>{
  // setcurrentPage(pageNo);
  // const startIndex = (pageNo-1) * pageSize;
  // const paginatedPost = _(allusers).slice(startIndex).take(pageSize).value();
  // setpaginatedPosts(paginatedPost)
  // }
  // --------------------//



  const [EditParoSectionTop ,SetEditParoSectionTop] =useState([]);

  /*----Get select to the particular Id----*/

 function ParoSelectTop(Id){

  const token = JSON.parse(localStorage.getItem('usertoken'));

  // document.getElementById("DisplayEditPoptop").style.display = "block";

  setFileA();
  setFileB();

   const body =
    {
      
     id:Id
    }
    console.log('body',body);

  
    axios({
           method:"POST",
           url :`${BASE_URL}/Paropakari/ParoSelectSectionTop`,
           data:body, 
           headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer " +`${token}` 
            }     
        }) 
        
   
        .then((response) =>{
          console.log("Topselection",response.data);
     
     
          SetEditParoSectionTop(response.data);


          localStorage.setItem("SetParotopLink", JSON.stringify(response.data));
          let checkLink=JSON.parse(localStorage.getItem('SetParotopLink'));
          let Check =checkLink.map((item) => item.image)
          let CheckA = Check[0]
          SetOldLink(CheckA)
              let CheckB= CheckA.slice(31);
              SetEditParoLink(CheckB)
              console.log("srdt",CheckB)

     
       })
       .catch(error => {
         console.log(error);
         
       })

 }
    

 //-----EDIT FUNCTION -----//

function editParoTop(Id){

  document.getElementById("DisplayEditPoptop").style.display = "block";

  ParoSelectTop(Id)
}



 /*----EditSection----*/

 function updateParoSectionTop(Id){

  var UserId= localStorage.getItem('UserId')
  const token = JSON.parse(localStorage.getItem('usertoken'));

  var Tittle = document.getElementById('ParotoptextA').value; 
   var Topdes= document.getElementById('ParotoptextB').value;
   var OldImage = OldLink;

    if(!Tittle){

      document.getElementById("UpdateSecTopErrA").innerHTML="Title Required";
     }

     else if(Tittle){
      document.getElementById("UpdateSecTopErrA").innerHTML=" ";

     }

     if(!Topdes){

      document.getElementById("UpdateSecTopErrB").innerHTML="Description Required";
     }

     else if(Topdes){
      document.getElementById("UpdateSecTopErrB").innerHTML=" ";

     }

    //  if(!file){

    //   document.getElementById("UpdateSecTopErrC").innerHTML="Image Required";

    // }
    // else if(file){

    //   document.getElementById("UpdateSecTopErrC").innerHTML=" ";

    // }

    if(Tittle&&Topdes){



 
  
   const body ={
    
     Id:Id,
     Title: Tittle,
     Description:Topdes,
     Image:fileA,
     oldImage:OldImage,
     Editedby:UserId
    
   }
   // console.log(body);


     axios({
   
       method: "POST",
       
       url: `${BASE_URL}/Paropakari/ParoEditSectionTop`,
       data:body,
       headers: {
         
         'Content-Type': 'multipart/form-data' ,    
         "Authorization": "Bearer " +`${token}`  
        
       }
     
     })
    
     .then((response) =>{
       console.log(response.data);
       if(response.data.status === "Success"){
    
              alert("Updated Successfully!")
             }
         
             setFileA();
             setFileB();
                 setTimeout(() => {
                  getparoTopsection()
                 
                   closeForm()
                   
                 }, 500);
               }
              
        )

      .catch(error => {
       console.log(error);
        alert("failed !")       
        })
     }
    }



     /*----del btn Onclick func----*/

 function  ParoSectionDeleteStatusTop(Id){
  const token = JSON.parse(localStorage.getItem('usertoken'));

 
  {const body ={
   id: Id
 }
  console.log('check',body)
   axios({
  
   method:"POST",
  url:`${BASE_URL}/Paropakari/ParoDeleteSectionTop`,
  data:body,
  headers: {
  "Content-Type" : "application/json",
  "Authorization": "Bearer " +`${token}`

  }
 
   })
   .then((response) =>{
   console.log(response.data);

   alert("Deleted Successfully !")
  //  toast.success("Section Deleted Successfully !", {
  //   position: "top-center",
  //   autoClose: 3200,
  //   hideProgressBar: false,
  //   closeOnClick: true,
  //   pauseOnHover: true,
  //   draggable: true,
  //   progress: undefined,
  //   className: 'toast-message'
  //   });
    setTimeout(() => {
      closeForm()
      getparoTopsection();
    }, 500);
  

   })}
  
    }   


    //-----DELETE FUNCTION -----//

function ConfirmDeleteTop(Id){


  document.getElementById("modalEditFormTop").style.display = "block";
  ParoSelectTop(Id)

}


    // --------------------------------//




/*----Open & Close Edit and Add popup----*/

function closeForm(){

  setFile();
  
 
  document.getElementById('DisplayEditPoptop').style.display="none";
 
  document.getElementById('ParosectionTopform').reset();

  document.getElementById('modalEditFormTop').style.display="none";
  // document.getElementById('modalEditForm').style.display="none";
  

  document.getElementById("UpdateSecTopErrA").innerHTML=" ";
  document.getElementById("UpdateSecTopErrB").innerHTML=" ";
  document.getElementById("UpdateSecTopErrC").innerHTML=" ";


}



 function closeTopform(){
  setFile();
  document.getElementById('DisplayAddPop').style.display="none";
document.getElementById('Parosectionform').reset();
  document.getElementById("AddSectopErrA").innerHTML=" ";
  document.getElementById("AddSectopErrB").innerHTML=" ";
  document.getElementById("AddSectopErrC").innerHTML=" ";

 }

 function openTopform(){

  document.getElementById('DisplayAddPop').style.display="block";


  
 
  }

  
  const LEFT_PAGE = "LEFT";
  const RIGHT_PAGE = "RIGHT";
  const range = (from, to, step = 1) => {
    let i = from;
    const range = [];
  
    while (i <= to) {
      range.push(i);
      i += step;
    }
  
    return range;
  };
  
  const [currentPage, setCurrentPage] = useState(1);
  
  let data = localStorage.getItem("Paro-TopData")
  let transdata =  JSON.parse(data);
  console.log(transdata,'aaaa')
  let NUM_OF_RECORDS = transdata.length;
  let LIMIT = 3;
  
  const onPageChanged = useCallback(
  
    (event, page) => {
      event.preventDefault();
      setCurrentPage(page);
    },
    [setCurrentPage]
    
  );
  
  
  const currentData = transdata.slice(
    (currentPage - 1) * LIMIT,
    (currentPage - 1) * LIMIT + LIMIT
  );
  
  const Paginations = (props) => {
    const {
      totalRecords,
      pageLimit,
      pageNeighbours,
      onPageChanged,
      currentPage
    } = props;
    const [totalPages, setTotalPages] = useState(0);
    useEffect(() => {
      setTotalPages(Math.ceil(totalRecords / pageLimit));
    }, [setTotalPages]);
  
    const fetchPageNumbers = () => {
      const totalNumbers = pageNeighbours * 1 + 0;
    
      const totalBlocks = totalNumbers + 2;
     
      if (totalPages > totalBlocks) {
        const startPage = Math.max(2, currentPage - pageNeighbours);
        const endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);
  
        let pages = range(startPage, endPage);
  
        const hasLeftSpill = startPage > 2;
        const hasRightSpill = totalPages - endPage > 1;
        const spillOffset = totalNumbers - (pages.length + 1);
  
        switch (true) {
          case hasLeftSpill && !hasRightSpill: {
            const extraPages = range(startPage - spillOffset, startPage - 1);
            pages = [LEFT_PAGE, ...extraPages, ...pages];
            break;
          }
          case hasLeftSpill && hasRightSpill:
          default: {
            pages = [LEFT_PAGE, ...pages, RIGHT_PAGE];
            break;
          }
        }
        return [1, ...pages, totalPages];
      }
      return range(1, totalPages);
    };
  
  
    const pages = fetchPageNumbers() || [];
    return (
      <nav aria-label="Countries Pagination">
        <ul className="pagination" id='Paro-pag'>
          {pages.map((page, index) => {
            if (page === LEFT_PAGE)
              return (
                <li key={index} className="Paropage-item">
                  <a
                    href="/"
                    className="page-link"
                    aria-label="Previous"
                    onClick={(e) => onPageChanged(e, pageNeighbours)}
                  >
                    <span aria-hidden="true">&laquo;</span>
                  </a>
                </li>
              );
  
            if (page === RIGHT_PAGE)
              return (
                <li key={index} className="Paropage-item">
                  <a
                    className="page-link"
                    href="/"
                    aria-label="Next"
                    onClick={(e) => onPageChanged(e, pageNeighbours*2+1 )}
                  >
                    <span aria-hidden="true">&raquo;</span>
                  </a>
                </li>
              );
  
            return (
              <li
                key={index}
                className={`Paropage-item${currentPage === page ? " active" : ""}`}
              >
                <a
                  className="page-link"
                  href="/"
                  onClick={(e) => onPageChanged(e, page)}
                >
                  {page}
                </a>
              </li>
            );
          })}
        </ul>
      </nav>
    );
  };

  return (
    <div className='Paro-addmain'>

<div className="Paro-addgrid-layout">
    <div className="Paro-addmain-top">
        <div className='Paro-addmain-back'>
           <Link to='/ParoIndex'><i class="fa fa-chevron-left" aria-hidden="true"></i></Link>
        </div> 
           <span>What we do</span>
 

     </div>
 </div>



<span id="Paroaction-err"></span>

 {/* AddSection Popup */}

<div className='Paropop-fade' id="DisplayAddPop">

<div className="modal-dialog" role="document" id="ParoEdittopform">
  <div className="modal-content">
    <div className="modal-header text-center">
      <h4 className="modal-title w-100 font-weight-bold">ADD SECTION</h4>
      <button type="button" className="close" onClick={closeTopform}>
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <form  id="Parosectionform" onSubmit={ParoAddsection} >
    <div className="modal-body mx-3">
      <div className="md-form mb-5">
        <label id="ParoSectionTable">Title</label>
        <input type="text" id="Parotexttop"/>
        <span id="AddSectopErrA" className='error'></span>
      </div>

      <div className="md-form mb-5">
      <label  id="ParoSectionTable">Description</label>
       <input type="text"  id="ParotextDes"  />
      <span id="AddSectopErrB" className='error'></span>
      </div>

      <div className="md-form mb-5">
      <label  id="ParoSectionTable">Image</label>
       <input type="file" onChange={handleFileChange}/>
      <span id="AddSectopErrC" className='error'></span>
      </div>
    </div>

    <div className="modal-footer d-flex justify-content-center">
      <button className='Paro-adduser-button' type="submit">Add</button>
    </div>
    </form>
  </div>
</div>

</div>


     
<div className='Paro-addmain-add'>
    <button className='Paro-add-user' id="Paro-section-btn" onClick={openTopform}>
    <i class="fa fa-plus-circle" ></i>&nbsp;Add Here</button>
</div>




    <div className='Paro-table'>
        <div class="Paro-table-responsive" id='Paro-TopTbl'>
        {
            !paginatedPosts ? ("No data found"):(
          <table>
            <thead>
              <tr>
                <th>Title</th>
                <th>Description</th>
                <th>Image</th>
                {Corpdisplay?<th>Action</th>:null}

</tr>
            </thead>
          
          <tbody>

            {currentData.map((e,index)=>
            {
              return<tr key={index}>
                <td>{e.title}</td>
                <td>{e.description}</td>
                <td><img src={e.image} id="section-image"/></td>

                 {Corpdisplay?<td  style={{whiteSpace:"nowrap"}} >
                {/* <span><i class="fa fa-trash" aria-hidden="true" onClick={()=>DeleteSectionA(e.id)} ></i></span> */}
                {CorpEditdisplay?<i class="fa fa-pencil" aria-hidden="true"  id="ParoEdit-icon" onClick={()=>editParoTop(e.id)}></i>:null}&nbsp;&nbsp;
                {CorpDeletedisplay?<i class="fa fa-trash" aria-hidden="true" id="ParoDelete-icon" onClick={()=>ConfirmDeleteTop(e.id)} ></i>:null}
              
              </td>:null}

              </tr>
            })}

        </tbody>
        </table>

)}

<br></br>

{transdata.length<=5? null:<div>
{
 !paginatedPosts ? (""):(

<Paginations



 totalRecords={NUM_OF_RECORDS}

 pageLimit={LIMIT}

 pageNeighbours={2}

 onPageChanged={onPageChanged}

 currentPage={currentPage}

 />

 )}
</div>}
  {/* <nav>
    <ul className='pagination'>
      {
        pages.map((page)=>(
          <li className={
            page === currentPage ? "page-item active" : "page-item"
          }>
            <p className='page-link'
            onClick={()=>pagination(page)}
            >
            {page}
            </p>
            </li>
        ))
      }
       

    </ul>
  </nav> */}
        </div>
        </div>


{/* EditPopup */}

<div className='Paropop-fade' id="DisplayEditPoptop">
{EditParoSectionTop.map((e)=>{
   return<div className="modal-dialog" role="document" id="ParoEdittopform" >
    <div className="modal-content">
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">EDIT SECTION</h4>
        <button type="button" className="close" onClick={closeForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form  id="ParosectionTopform" onSubmit={()=>updateParoSectionTop(e.id)}>
      <div className="modal-body mx-3">
        <div className="md-form mb-5">
        <label id="ParoSectionTable">Title</label> 
          <input type="text" id="ParotoptextA"  defaultValue={e.title}/>
          <span id="UpdateSecTopErrA" className='error'></span>
        </div> 

        <div className="md-form mb-5">
        <label id="ParoSectionTable">Description</label> 
          <input type="text" id="ParotoptextB"  defaultValue={e.description}/>
          <span id="UpdateSecTopErrB" className='error'></span>
        </div> 

        {/* <div className="md-form mb-5">
        <label id="ParoSectionTable">Image</label> 
         <input type="file" onChange={handleFileChange}/>
         <span id="UpdateSecTopErrC" className='error'></span>
        </div> */}

<div className="md-form mb-5">
        <label id="ParoSectionTable">Image</label> 
        {!fileA? <div>
          <input type="file"  style={{opacity:"0",position:"relative",top:"50px",left:"0px",zIndex:"1",top:"0"}} onChange={handleFileChangeA} id="ParotextG"/>

<div style={{border:"1px solid lightgrey" ,padding:"1px 12px 1px 12px",borderRadius:"2px",marginTop:"-50px"}}>
<input defaultValue={EditParoLink}  id="oldEventFound"style={{border:"none",marginLeft:"84px",background:"transparent",position:"relative"}}/>
 <span style={{border:"1px solid black",backgroundColor:"#efefef",padding:"2px 2px 2px",borderRadius:"2px",position:"absolute",marginTop:"-38px"}}>Choose File</span>
 {/* &nbsp;<span >{e.fileName}</span> */}
 </div>

</div> 
         
        
        :
<div>
        <form id="Parochangeinput"><input type="file" style={{opacity:"0",position:"relative",top:"50px",left:"0px",zIndex:"1",top:"0"}} onChange={handleFileChangeA}/>
        <div style={{border:"1px solid lightgrey" ,padding:"1px 12px 1px",borderRadius:"2px",marginTop:"-50px",color:"red"}}>
        <input defaultValue={fileB}  style={{border:"none",marginLeft:"84px",background:"transparent",position:"relative"}}/>
         <span style={{border:"1px solid black",backgroundColor:"#efefef",padding:"2px 2px 2px",borderRadius:"2px",position:"absolute",marginTop:"-38px"}}>Choose File</span>
      
         </div></form> <input defaultValue={e.image} id="oldEventFound" style={{display:"none"}} />
                        
                        </div>
                        }
                          <span id="UpdateSecTopErrC" className='error'></span>
       
      
     

                          </div>
        
      </div>

      <div className="modal-footer d-flex justify-content-center">
        <button className='Paro-adduser-button' type="submit">Update</button>
      </div>
      </form>
    </div>
  </div>})}

</div>



<div className="Paropop-fade" id="modalEditFormTop" tabindex="-1" role="dialog">
{EditParoSectionTop.map((e)=>{
   return<div className="modal-dialog" role="document" id="ParocenterDelform">
    <div className="modal-content">
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">DELETE</h4>
        <button type="button" className="close" onClick={closeForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

<form id='formTop'>

   <div className="modal-body mx-3">

        <div className="md-form mb-5">
            <div className='text-center'>
          <h5 id="Parodelformsize"><img src={Index} id="causeimg"></img><br></br>Are you sure want to delete?</h5>
          </div>
        </div>

   </div>

      <div className="modal-footer d-flex justify-content-center">
        <button className="Paro-delete-button" type='submit' onClick={()=> ParoSectionDeleteStatusTop(e.id)}>Confirm</button>
        <button className="Paro-delete-button" onClick={closeForm} type='submit'>Cancel</button>
      </div>

      </form>
      
    </div>
  </div>
  })}
</div>

</div>
  )
}

export default ParoSectionIndexTopMain